import { SERVICE_HOST } from "../utils/auth/config";

export const STUDENT_INFO = `${SERVICE_HOST}/student-info/v1`;

export const GUARDIAN_INFO_BY_USERNAME = `${STUDENT_INFO}/guardian`; // /<username>/detail.json
export const STUDENT_INFO_BY_STUDENTNUMBER = `${STUDENT_INFO}/studentNumber`; // /<{studentNumber}/summary.json>
export const STUDENT_INFO_STUDENT = `${STUDENT_INFO}/student`;
